import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_2 = { class: "input-group top_search" };
const _hoisted_3 = {
    key: 0,
    class: "multiselect__single"
};
const _hoisted_4 = { class: "multiselect-actions" };
const _hoisted_5 = ["disabled"];
const _hoisted_6 = ["disabled"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "font-weight-normal" };
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_10 = { class: "input-group top_search" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_13 = { class: "checkbox-wrapper" };
const _hoisted_14 = { class: "float-end float-start-sm" };
const _hoisted_15 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_16 = {
    key: 0,
    class: "bottom10"
};
const _hoisted_17 = { class: "mt-0" };
const _hoisted_18 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_19 = { class: "input-group top_search" };
const _hoisted_20 = {
    key: 0,
    class: "multiselect__single"
};
const _hoisted_21 = { class: "multiselect-actions" };
const _hoisted_22 = ["disabled"];
const _hoisted_23 = ["disabled"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = { class: "font-weight-normal" };
const _hoisted_26 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_27 = { class: "input-group top_search" };
const _hoisted_28 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_29 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_30 = { class: "checkbox-wrapper" };
const _hoisted_31 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_radio = _resolveComponent("b-form-radio");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_modal = _resolveComponent("b-modal");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _directive_standard_or_higher = _resolveDirective("standard-or-higher");
    return (_ctx.isModal)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_b_modal, {
                modelValue: _ctx.showModal,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.showModal) = $event)),
                id: "modal-summary-status-report",
                "header-bg-variant": "normal",
                size: "lg"
            }, {
                title: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("\r\n\t\t\t\tSummary Status Report\r\n\t\t\t", -1 /* CACHED */)
                    ]))]),
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "primary",
                            onClick: _ctx.generateSummaryStatusReport
                        }, {
                            default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                    _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* CACHED */),
                                    _createTextVNode(" Export PDF\r\n\t\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]),
                        _cache[36] || (_cache[36] = _createTextVNode()),
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "primary",
                            onClick: _ctx.exportToCsv
                        }, {
                            default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                    _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* CACHED */),
                                    _createTextVNode(" Export CSV\r\n\t\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]),
                        _cache[37] || (_cache[37] = _createTextVNode()),
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "secondary",
                            onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.showModal = false))
                        }, {
                            default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                    _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                    _createTextVNode(" Close\r\n\t\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        })
                    ])
                ]),
                default: _withCtx(() => [
                    _cache[38] || (_cache[38] = _createTextVNode()),
                    _createVNode(_component_b_container, { clearfix: "" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_multiselect, {
                                        options: _ctx.companies,
                                        "track-by": "value",
                                        label: "text",
                                        multiple: true,
                                        showLabels: false,
                                        placeholder: "",
                                        preserveSearch: true,
                                        closeOnSelect: false,
                                        class: "multiselect-small",
                                        useTeleport: true
                                    }, {
                                        noResult: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        placeholder: _withCtx(() => [...(_cache[16] || (_cache[16] = []))]),
                                        selection: _withCtx(({ search, isOpen }) => [
                                            (!isOpen)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.companyOptionText), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        beforeList: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_4, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    onClick: _cache[0] || (_cache[0] = _withModifiers(
                                                    //@ts-ignore
                                                    (...args) => (_ctx.selectAllCompanies && _ctx.selectAllCompanies(...args)), ["stop"])),
                                                    disabled: !_ctx.canSelectAll,
                                                    class: "btn-link"
                                                }, "Select All", 8 /* PROPS */, _hoisted_5),
                                                _cache[17] || (_cache[17] = _createTextVNode()),
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    onClick: _cache[1] || (_cache[1] = _withModifiers(
                                                    //@ts-ignore
                                                    (...args) => (_ctx.unselectAllCompanies && _ctx.unselectAllCompanies(...args)), ["stop"])),
                                                    disabled: !_ctx.canUnselectAll,
                                                    class: "btn-link"
                                                }, "Unselect All", 8 /* PROPS */, _hoisted_6)
                                            ])
                                        ]),
                                        option: _withCtx((props) => [
                                            _createElementVNode("div", {
                                                onClick: _withModifiers(($event) => (_ctx.selectCompany(props.option)), ["stop"])
                                            }, [
                                                (_openBlock(), _createBlock(_component_b_form_checkbox, {
                                                    id: 'company-' + props.option.value,
                                                    key: _ctx.getCompanyComponentKey(props.option),
                                                    checked: props.option.selected
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("label", _hoisted_8, _toDisplayString(props.option.text), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "checked"]))
                                            ], 8 /* PROPS */, _hoisted_7)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["options"])
                                ])
                            ]),
                            _cache[29] || (_cache[29] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createVNode(_component_multiselect, {
                                        modelValue: _ctx.selectedSite,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.selectedSite) = $event)),
                                        options: _ctx.sitesFiltered,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "All sites",
                                        class: "multiselect-small",
                                        useTeleport: true,
                                        disabled: _ctx.isSiteDropdownDisabled
                                    }, {
                                        noResult: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                                ])
                            ]),
                            _cache[30] || (_cache[30] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_11, [
                                _cache[26] || (_cache[26] = _createElementVNode("label", null, "Recent Alarms Period: ", -1 /* CACHED */)),
                                _cache[27] || (_cache[27] = _createTextVNode()),
                                _createVNode(_component_b_form_group, { label: "" }, {
                                    default: _withCtx(({ ariaDescribedby }) => [
                                        _createVNode(_component_b_form_radio, {
                                            inline: "",
                                            modelValue: _ctx.recentAlarmsPeriod,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.recentAlarmsPeriod) = $event)),
                                            "aria-describedby": ariaDescribedby,
                                            name: "recentAlarmsPeriod",
                                            value: "7"
                                        }, {
                                            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                                    _createTextVNode("7 days", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue", "aria-describedby"]),
                                        _cache[25] || (_cache[25] = _createTextVNode()),
                                        _createVNode(_component_b_form_radio, {
                                            inline: "",
                                            modelValue: _ctx.recentAlarmsPeriod,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.recentAlarmsPeriod) = $event)),
                                            "aria-describedby": ariaDescribedby,
                                            name: "recentAlarmsPeriod",
                                            value: "28"
                                        }, {
                                            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                                    _createTextVNode("4 weeks", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue", "aria-describedby"])
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _cache[31] || (_cache[31] = _createTextVNode()),
                            _createCommentVNode("<div class=\"col-xs-12 col-sm-12 col-md-6\">\r\n\t\t<div class=\"input-group top_search\">\r\n\t\t\t<multiselect v-model=\"alarmType\" :options=\"alarmTypes\" track-by=\"value\" label=\"text\" :showLabels=\"false\" placeholder=\"All alarm types\" class=\"multiselect-small\">\r\n\t\t\t\t<template #noResult>\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t</template>\r\n\t\t\t</multiselect>\r\n\t\t</div>\r\n\t</div>\r\n\t<div class=\"col-xs-12 col-sm-12 col-md-6\">\r\n\t\t<div class=\"input-group top_search\">\r\n\t\t\t<multiselect :options=\"systemStates\"\r\n\t\t\t\t\t\t track-by=\"value\"\r\n\t\t\t\t\t\t label=\"text\"\r\n\t\t\t\t\t\t :multiple=\"true\"\r\n\t\t\t\t\t\t :showLabels=\"false\"\r\n\t\t\t\t\t\t placeholder=\"\"\r\n\t\t\t\t\t\t :preserveSearch=\"true\"\r\n\t\t\t\t\t\t :closeOnSelect=\"false\"\r\n\t\t\t\t\t\t class=\"multiselect-small\">\r\n\t\t\t\t<template #noResult>\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t</template>\r\n\t\t\t\t<template #placeholder>\r\n\t\t\t\t\t<span v-if=\"!numberOfSeletedStatus\">\r\n\t\t\t\t\t\tNone selected\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</template>\r\n\t\t\t\t<template #selection=\"{ search, isOpen }\">\r\n\t\t\t\t\t<span class=\"multiselect__single\" v-if=\"numberOfSeletedStatus && !isOpen\">{{ statusOptionText }}</span>\r\n\t\t\t\t</template>\r\n\t\t\t\t<template #option=\"props\">\r\n\t\t\t\t\t<div @click.stop=\"selectStatus(props.option)\">\r\n\t\t\t\t\t\t<b-form-checkbox :id=\"'status-' + props.option.value\" :key=\"getComponentKey(props.option)\" :checked=\"props.option.selected\">\r\n\t\t\t\t\t\t\t<label class=\"font-weight-normal\">\r\n\t\t\t\t\t\t\t\t{{ props.option.text }}\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t</b-form-checkbox>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</template>\r\n\t\t\t</multiselect>\r\n\t\t</div>\r\n\t</div>"),
                            _cache[32] || (_cache[32] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_component_b_form_checkbox, {
                                        modelValue: _ctx.hideSiteName,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.hideSiteName) = $event)),
                                        size: "lg"
                                    }, {
                                        default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                                _createTextVNode("\r\n\t\t\t\t\t\t\tHide site name columns\r\n\t\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue"])
                                ])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _cache[39] || (_cache[39] = _createTextVNode())
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]),
            _cache[40] || (_cache[40] = _createTextVNode()),
            _createVNode(_component_StatusOverlayComponent, {
                visible: _ctx.working,
                message: "Loading..."
            }, null, 8 /* PROPS */, ["visible"])
        ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_15, [
                (_ctx.reportScheduledModel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("h2", _hoisted_17, [
                            _cache[41] || (_cache[41] = _createTextVNode("Editing schedule report ", -1 /* CACHED */)),
                            _createElementVNode("b", null, _toDisplayString(_ctx.reportScheduledModel.description), 1 /* TEXT */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _cache[61] || (_cache[61] = _createTextVNode()),
            _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_multiselect, {
                        options: _ctx.companies,
                        "track-by": "value",
                        label: "text",
                        multiple: true,
                        showLabels: false,
                        placeholder: "",
                        preserveSearch: true,
                        closeOnSelect: false,
                        class: "multiselect-small"
                    }, {
                        noResult: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                _createTextVNode("\r\n\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        placeholder: _withCtx(() => [...(_cache[43] || (_cache[43] = []))]),
                        selection: _withCtx(({ search, isOpen }) => [
                            (!isOpen)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.companyOptionText), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                        ]),
                        beforeList: _withCtx(() => [
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[8] || (_cache[8] = _withModifiers(
                                    //@ts-ignore
                                    (...args) => (_ctx.selectAllCompanies && _ctx.selectAllCompanies(...args)), ["stop"])),
                                    disabled: !_ctx.canSelectAll,
                                    class: "btn-link"
                                }, "Select All", 8 /* PROPS */, _hoisted_22),
                                _cache[44] || (_cache[44] = _createTextVNode()),
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[9] || (_cache[9] = _withModifiers(
                                    //@ts-ignore
                                    (...args) => (_ctx.unselectAllCompanies && _ctx.unselectAllCompanies(...args)), ["stop"])),
                                    disabled: !_ctx.canUnselectAll,
                                    class: "btn-link"
                                }, "Unselect All", 8 /* PROPS */, _hoisted_23)
                            ])
                        ]),
                        option: _withCtx((props) => [
                            _createElementVNode("div", {
                                onClick: _withModifiers(($event) => (_ctx.selectCompany(props.option)), ["stop"])
                            }, [
                                (_openBlock(), _createBlock(_component_b_form_checkbox, {
                                    id: 'company-' + props.option.value,
                                    key: _ctx.getCompanyComponentKey(props.option),
                                    checked: props.option.selected
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("label", _hoisted_25, _toDisplayString(props.option.text), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "checked"]))
                            ], 8 /* PROPS */, _hoisted_24)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["options"])
                ])
            ]),
            _cache[62] || (_cache[62] = _createTextVNode()),
            _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_multiselect, {
                        modelValue: _ctx.selectedSite,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.selectedSite) = $event)),
                        options: _ctx.sitesFiltered,
                        "track-by": "value",
                        label: "text",
                        showLabels: false,
                        placeholder: "All sites",
                        class: "multiselect-small",
                        disabled: _ctx.isSiteDropdownDisabled
                    }, {
                        noResult: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                _createTextVNode("\r\n\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                ])
            ]),
            _cache[63] || (_cache[63] = _createTextVNode()),
            _createElementVNode("div", _hoisted_28, [
                _cache[53] || (_cache[53] = _createElementVNode("label", null, "Recent Alarms Period: ", -1 /* CACHED */)),
                _cache[54] || (_cache[54] = _createTextVNode()),
                _createVNode(_component_b_form_group, { label: "" }, {
                    default: _withCtx(({ ariaDescribedby }) => [
                        _createVNode(_component_b_form_radio, {
                            inline: "",
                            modelValue: _ctx.recentAlarmsPeriod,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.recentAlarmsPeriod) = $event)),
                            "aria-describedby": ariaDescribedby,
                            name: "recentAlarmsPeriod",
                            value: "7"
                        }, {
                            default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                    _createTextVNode("7 days", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue", "aria-describedby"]),
                        _cache[52] || (_cache[52] = _createTextVNode()),
                        _createVNode(_component_b_form_radio, {
                            inline: "",
                            modelValue: _ctx.recentAlarmsPeriod,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.recentAlarmsPeriod) = $event)),
                            "aria-describedby": ariaDescribedby,
                            name: "recentAlarmsPeriod",
                            value: "28"
                        }, {
                            default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                    _createTextVNode("4 weeks", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue", "aria-describedby"])
                    ]),
                    _: 1 /* STABLE */
                })
            ]),
            _cache[64] || (_cache[64] = _createTextVNode()),
            _createCommentVNode("<div class=\"col-xs-12 col-sm-12 col-md-6\">\r\n\t\t<div class=\"input-group top_search\">\r\n\t\t\t<multiselect v-model=\"alarmType\" :options=\"alarmTypes\" track-by=\"value\" label=\"text\" :showLabels=\"false\" placeholder=\"All alarm types\" class=\"multiselect-small\">\r\n\t\t\t\t<template #noResult>\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t</template>\r\n\t\t\t</multiselect>\r\n\t\t</div>\r\n\t</div>\r\n\t<div class=\"col-xs-12 col-sm-12 col-md-6\">\r\n\t\t<div class=\"input-group top_search\">\r\n\t\t\t<multiselect :options=\"systemStates\"\r\n\t\t\t\t\t\t track-by=\"value\"\r\n\t\t\t\t\t\t label=\"text\"\r\n\t\t\t\t\t\t :multiple=\"true\"\r\n\t\t\t\t\t\t :showLabels=\"false\"\r\n\t\t\t\t\t\t placeholder=\"\"\r\n\t\t\t\t\t\t :preserveSearch=\"true\"\r\n\t\t\t\t\t\t :closeOnSelect=\"false\"\r\n\t\t\t\t\t\t class=\"multiselect-small\">\r\n\t\t\t\t<template #noResult>\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t</template>\r\n\t\t\t\t<template #placeholder>\r\n\t\t\t\t\t<span v-if=\"!numberOfSeletedStatus\">\r\n\t\t\t\t\t\tNone selected\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</template>\r\n\t\t\t\t<template #selection=\"{ search, isOpen }\">\r\n\t\t\t\t\t<span class=\"multiselect__single\" v-if=\"numberOfSeletedStatus && !isOpen\">{{ statusOptionText }}</span>\r\n\t\t\t\t</template>\r\n\t\t\t\t<template #option=\"props\">\r\n\t\t\t\t\t<div @click.stop=\"selectStatus(props.option)\">\r\n\t\t\t\t\t\t<b-form-checkbox :id=\"'status-' + props.option.value\" :key=\"getComponentKey(props.option)\" :checked=\"props.option.selected\">\r\n\t\t\t\t\t\t\t<label class=\"font-weight-normal\">\r\n\t\t\t\t\t\t\t\t{{ props.option.text }}\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t</b-form-checkbox>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</template>\r\n\t\t\t</multiselect>\r\n\t\t</div>\r\n\t</div>"),
            _cache[65] || (_cache[65] = _createTextVNode()),
            _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_b_form_checkbox, {
                        modelValue: _ctx.hideSiteName,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.hideSiteName) = $event)),
                        size: "lg"
                    }, {
                        default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                _createTextVNode("\r\n\t\t\t\t\tHide Site Name Columns\r\n\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                ])
            ]),
            _cache[66] || (_cache[66] = _createTextVNode()),
            _createElementVNode("div", _hoisted_31, [
                _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                    type: "button",
                    variant: "primary",
                    onClick: _ctx.schedule
                }, {
                    default: _withCtx(() => [
                        _cache[56] || (_cache[56] = _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* CACHED */)),
                        _createTextVNode(" " + _toDisplayString(_ctx.getScheduleButtonLabel()), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])), [
                    [_directive_standard_or_higher]
                ]),
                _cache[59] || (_cache[59] = _createTextVNode()),
                _createVNode(_component_b_button, {
                    type: "button",
                    variant: "primary",
                    onClick: _ctx.generateSummaryStatusReport
                }, {
                    default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                            _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* CACHED */),
                            _createTextVNode(" Export PDF\r\n\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"]),
                _cache[60] || (_cache[60] = _createTextVNode()),
                _createVNode(_component_b_button, {
                    type: "button",
                    variant: "primary",
                    onClick: _ctx.exportToCsv
                }, {
                    default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                            _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* CACHED */),
                            _createTextVNode(" Export CSV\r\n\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
            ]),
            _cache[67] || (_cache[67] = _createTextVNode()),
            _createVNode(_component_StatusOverlayComponent, {
                visible: _ctx.working,
                message: "Loading..."
            }, null, 8 /* PROPS */, ["visible"])
        ], 64 /* STABLE_FRAGMENT */));
}
